import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Badge} from 'reactstrap';

import { format } from "date-fns";
import { fr } from "date-fns/locale";
//import { formatInTimeZone } from 'date-fns-tz'




const PreRegistrationStatus = ({ status }) => {
  switch (status) {
    case "En attente":
      return <Badge className="bg-warning"> {status} </Badge>;

    case "Rejetée":
      return <Badge className="bg-danger"> {status} </Badge>;

    case "Validée":
      return <Badge className="bg-success"> {status} </Badge>;

    default:
      return <Badge className="bg-success"> {status} </Badge>;
  }
};



//import images
//import wechat from "../../../assets/images/companies/wechat.svg";

const DetailsSection = ({ preRegistration }) => {
    return (
        <React.Fragment>
            <Col xl={9}>
                <Card>
                    <CardBody className="border-bottom">
                        <div className="d-flex">
                            {/*<img src={wechat} alt="" height="50" />*/}
                            <div className="flex-grow-1 ms-3">
                                <h5 className="fw-semibold">{preRegistration.first_name}  {preRegistration.last_name}</h5>
                                <ul className="list-unstyled hstack gap-2 mb-0">
                                    <li>
                                        <i className="bx bx-phone-call"></i> <span className="text-muted">{preRegistration.phone}</span>
                                    </li>
                                    <li>
                                        <i className="bx bx-envelope"></i> <span className="text-muted">{preRegistration.email}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </CardBody>
                    <CardBody>
                         <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th scope="col">Sexe</th>
                                        <td scope="col">{preRegistration.sex}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Date de naissance:</th>
                                        <td>{ format(preRegistration.birth_date, "dd/MM/yyyy", { locale: fr })}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Lieu de naissance</th>
                                        <td>{preRegistration.birth_place}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Nationalité</th>
                                        <td><span className="badge badge-soft-success">{preRegistration.nationality}</span></td>
                                    </tr>
                                    
                                    <tr>
                                        <th scope="row">Faculté</th>
                                        <td>{preRegistration.faculty_name}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Filière</th>
                                        <td>{preRegistration.branch_name}</td>
                                    </tr>
                                    
                                    
                                    <tr>
                                        <th scope="row">Année du BAC</th>
                                        <td>{preRegistration.baccalaureate_year}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Série du BAC</th>
                                        <td>{preRegistration.baccalaureate_series}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Mention</th>
                                        <td>{preRegistration.mention_title}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Matricule CNOU</th>
                                        <td>{preRegistration.cnou_registration_number}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Prénom du père</th>
                                        <td>{preRegistration.father_firstname}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Prénom mère</th>
                                        <td>{preRegistration.mother_firstname}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Nom mère</th>
                                        <td>{preRegistration.mother_lastname}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Nom tuteur</th>
                                        <td>{preRegistration.tutor_name}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Téléphone tuteur</th>
                                        <td>{preRegistration.tutor_phone}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Situation familliale</th>
                                        <td>{preRegistration.family_situation}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Lieu de résidence</th>
                                        <td>{preRegistration.residence_place}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">État</th>
                                        <td>{<PreRegistrationStatus status={preRegistration.status} /> }</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default DetailsSection;